import { motion } from "framer-motion";
import { Building } from "lucide-react";
import { MUNICIPALITIES } from "@/data/content";
import { SectionHeader } from "@/components/ui-bits";
import { staggerParent, staggerChild } from "@/components/motion-primitives";

export const Municipalities = () => (
  <section className="relative py-24 md:py-32 bg-muted/40">
    <div className="container mx-auto px-4 md:px-8">
      <SectionHeader
        center
        overline="Coverage"
        title="Municipalities we assist with"
        subtitle="We assist clients with account-related matters across major South African municipalities and utility providers."
      />
      <motion.div
        variants={staggerParent} initial="hidden" whileInView="show" viewport={{ once: true }}
        className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto"
      >
        {MUNICIPALITIES.map((m, i) => (
          <motion.div
            key={i} variants={staggerChild} data-testid={`municipality-${i}`}
            className="flex items-center gap-3 rounded-xl bg-white border border-slate-200/80 px-5 py-5 hover:border-secondary/50 transition-colors"
          >
            <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/5 text-secondary shrink-0">
              <Building className="w-5 h-5" />
            </span>
            <span className="text-sm font-semibold text-primary leading-snug">{m}</span>
          </motion.div>
        ))}
      </motion.div>
      <p className="mt-8 text-center text-xs text-muted-foreground max-w-2xl mx-auto">
        SML is not part of, and does not officially represent or claim partnership or endorsement by any municipality.
        We assist clients with account-related matters only.
      </p>
    </div>
  </section>
);
